import { render, staticRenderFns } from "./TextPopover.vue?vue&type=template&id=59856424&"
import script from "./TextPopover.vue?vue&type=script&lang=js&"
export * from "./TextPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports